import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import LotInfoModal from "../../../../modal/PC/stock/LotInfoModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';

const LotInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [statusOption, setStatusOption] = useState([]);
    const [keyword, setKeyword] = useState({
        start_date: appStore.YYYY_MM_DD(),
        end_date: appStore.YYYY_MM_DD(),
        status:'C',
        search:''
    });
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectLotNo, setSelectLotNo] = useState('');
    const [selectLotNoStatusName, setSelectLotNoStatusName] = useState('');
    const [selectLotCreateTypeName, setSelectLotCreateTypeName] = useState('');
    const [selectLotCreateDatetime, setSelectLotCreateDatetime] = useState('');
    const [selectLotDeleteTypeName, setSelectLotDeleteTypeName] = useState('');
    const [selectLotDeleteDatetime, setSelectLotDeleteDatetime] = useState('');
    const [selectItemTypeName, setSelectItemTypeName] = useState('');
    const [selectItemDivisionName, setSelectItemDivisionName] = useState('');
    const [selectItemName, setSelectItemName] = useState('');
    const [selectItemSpec, setSelectItemSpec] = useState('');
    const [selectLotSaveName, setSelectLotSaveName] = useState('');
    const [selectLotPlanDatetime, setSelectLotPlanDatetime] = useState('');
    const [selectLotLossDatetime, setSelectLotLossDatetime] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        viewer: true,
        id: false,
        company_id: false,
        item_lotno: true,
        item_lotno_status: false,
        item_lotno_status_name: true,
        item_lot_create_type: false,
        item_lot_create_type_name: true,
        item_lot_create_datetime: true,
        item_lot_delete_type: false,
        item_lot_delete_type_name: true,
        item_lot_delete_datetime: true,
        item_id: false,
        item_version_seq: false,
        item_name: true,
        item_spec: true,
        item_width: false,
        item_depth: false,
        item_height: false,
        item_type: false,
        item_type_name: true,
        item_division: false,
        item_division_name: true,
        item_lot_c_produce_work_id: false,
        item_lot_c_incoming_id: false,
        item_lot_c_stock_adjustment_id: false,
        item_lot_c_quality_id: false,
        item_lot_l_loss_id: false,
        item_lot_p_produce_work_id: false,
        item_lot_d_produce_work_id: false,
        item_lot_d_outgoing_id: false,
        item_lot_d_stock_adjustment_id: false,
        item_lot_d_quality_discard_id: false,
        item_lot_d_discard_id: false,
        item_lot_save_workplace_id: false,
        item_lot_save_warehouse_id: false,
        item_lot_save_section_id: false,
        item_lot_save_workplace_name: false,
        item_lot_save_warehouse_name: false,
        item_lot_save_section_name: false,
        item_lot_save_name: true,
        item_lot_plan_datetime: false,
        item_lot_loss_datetime: false
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(MenuID !== 0 && statusOption != []){
            handleView();
        }
    }, [keyword.status, keyword.start_date, keyword.end_date])
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    // Grid정의
    const handleSetting = () => {
        setColumns([
            {
                field: 'viewer',
                headerName: '상세',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<AssignmentIcon color={"primary"} />} onClick={() => {DetailClick(params)}} label="Viewer" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'item_lotno', width: 0, headerAlign: 'center' },
            { field: 'company_id', headerName: 'company_id', width: 0, headerAlign: 'center' },
            { field: 'item_lotno', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
            { field: 'item_lotno_status', headerName: 'item_lotno_status', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lotno_status_name', headerName: '상태', width: 60, headerAlign: 'center', align:'center' },
            { field: 'item_lot_create_type', headerName: 'item_lot_create_type', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_create_type_name', headerName: '생성유형', width: 90, headerAlign: 'center', align:'center' },
            { field: 'item_lot_create_datetime', headerName: '생성일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'item_lot_delete_type', headerName: 'item_lot_delete_type', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_delete_type_name', headerName: '소멸유형', width: 90, headerAlign: 'center', align:'center' },
            { field: 'item_lot_delete_datetime', headerName: '소멸일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'item_id', headerName: 'item_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_version_seq', headerName: 'item_version_seq', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_name', headerName: '품목명', width: 160, headerAlign: 'center', align:'left' },
            { field: 'item_type', headerName: 'item_type', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_type_name', headerName: '유형', width: 80, headerAlign: 'center', align:'center' },
            { field: 'item_division', headerName: 'item_division', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_division_name', headerName: '분류', width: 120, headerAlign: 'center', align:'center' },
            { field: 'item_spec', headerName: '규격', width: 250, headerAlign: 'center', align:'left' },
            { field: 'item_width', headerName: 'item_width', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_depth', headerName: 'item_depth', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_height', headerName: 'item_height', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_c_produce_work_id', headerName: 'item_lot_c_produce_work_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_c_incoming_id', headerName: 'item_lot_c_incoming_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_c_stock_adjustment_id', headerName: 'item_lot_c_stock_adjustment_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_c_quality_id', headerName: 'item_lot_c_quality_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_l_loss_id', headerName: 'item_lot_l_loss_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_p_produce_work_id', headerName: 'item_lot_p_produce_work_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_d_produce_work_id', headerName: 'item_lot_d_produce_work_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_d_outgoing_id', headerName: 'item_lot_d_outgoing_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_d_stock_adjustment_id', headerName: 'item_lot_d_stock_adjustment_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_d_quality_discard_id', headerName: 'item_lot_d_quality_discard_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_d_discard_id', headerName: 'item_lot_d_discard_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_save_workplace_id', headerName: 'item_lot_save_workplace_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_save_warehouse_id', headerName: 'item_lot_save_warehouse_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_save_section_id', headerName: 'item_lot_save_section_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_save_workplace_name', headerName: '사업장', width: 0, headerAlign: 'center', align:'left' },
            { field: 'item_lot_save_warehouse_name', headerName: '창고', width: 0, headerAlign: 'center', align:'left' },
            { field: 'item_lot_save_section_name', headerName: '구역', width: 0, headerAlign: 'center', align:'left' },
            { field: 'item_lot_save_name', headerName: '보관장소', width: 270, headerAlign: 'center', align:'left' },
            { field: 'item_lot_plan_datetime', headerName: '계획일시', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_lot_loss_datetime', headerName: '분실일시', width: 0, headerAlign: 'center', align:'center' },
        ]);
    }
    
    // Grid 데이터 조회
    const handleView = () => {
        if(keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date < '2049-12-31' && keyword.end_date < '2049-12-31'){
            if (keyword.search === '' && keyword.start_date !== keyword.end_date) {
                Swal.fire({
                    title: '<p style="color:red">검색 오류</p>',
                    text: '조회기간이 1일을 초과하면 검색어가 반드시 필요합니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer:5000,
                    timerProgressBar: true
                });
                return;
            }else if (new Date(keyword.end_date) - new Date(keyword.start_date) >= 31 * 24 * 60 * 60 * 1000) {
                Swal.fire({
                    title: '<p style="color:red">검색 오류</p>',
                    text: '조회기간이 1달을 초과할 수 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer:5000,
                    timerProgressBar: true
                });
                return;
            }
            axios.get('/api/p/LotInfo/List',
                {
                params : {
                    status : keyword.status,
                    start_date : keyword.start_date,
                    end_date : keyword.end_date,
                    search: keyword.search
                }
            },
            { withCredentials: true }
            )
            .then((response) => {
                const array = response.data.map((item, index) => ({
                    id: item.item_lotno,
                    company_id: item.company_id,
                    item_lotno: item.item_lotno,
                    item_lotno_status: item.item_lotno_status,
                    item_lotno_status_name: item.item_lotno_status_name,
                    item_lot_create_type: item.item_lot_create_type,
                    item_lot_create_type_name: item.item_lot_create_type_name,
                    item_lot_create_datetime: item.item_lot_create_datetime === undefined?'':Moment(item.item_lot_create_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    item_lot_delete_type: item.item_lot_delete_type,
                    item_lot_delete_type_name: item.item_lot_delete_type_name,
                    item_lot_delete_datetime: item.item_lot_delete_datetime === undefined?'':Moment(item.item_lot_delete_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    item_id: item.item_id,
                    item_version_seq: item.item_version_seq,
                    item_name: item.item_name,
                    item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
                    item_width: item.item_width,
                    item_depth: item.item_depth,
                    item_height: item.item_height,
                    item_type: item.item_type,
                    item_type_name: item.item_type_name,
                    item_division: item.item_division,
                    item_division_name: item.item_division_name,
                    item_lot_c_produce_work_id: item.item_lot_c_produce_work_id,
                    item_lot_c_incoming_id: item.item_lot_c_incoming_id,
                    item_lot_c_stock_adjustment_id: item.item_lot_c_stock_adjustment_id,
                    item_lot_c_quality_id: item.item_lot_c_quality_id,
                    item_lot_l_loss_id: item.item_lot_l_loss_id,
                    item_lot_p_produce_work_id: item.item_lot_p_produce_work_id,
                    item_lot_d_produce_work_id: item.item_lot_d_produce_work_id,
                    item_lot_d_outgoing_id: item.item_lot_d_outgoing_id,
                    item_lot_d_stock_adjustment_id: item.item_lot_d_stock_adjustment_id,
                    item_lot_d_quality_discard_id: item.item_lot_d_quality_discard_id,
                    item_lot_d_discard_id: item.item_lot_d_discard_id,
                    item_lot_save_workplace_id: item.item_lot_save_workplace_id,
                    item_lot_save_warehouse_id: item.item_lot_save_warehouse_id,
                    item_lot_save_section_id: item.item_lot_save_section_id,
                    item_lot_save_workplace_name: item.item_lot_save_workplace_name,
                    item_lot_save_warehouse_name: item.item_lot_save_warehouse_name,
                    item_lot_save_section_name: item.item_lot_save_section_name,
                    item_lot_save_name: ((item.item_lot_save_workplace_name === ''? '':item.item_lot_save_workplace_name + ' ') + (item.item_lot_save_warehouse_name === ''? '':item.item_lot_save_warehouse_name + ' ') + (item.item_lot_save_section_name === ''? '':item.item_lot_save_section_name)).trim(),
                    item_lot_plan_datetime: item.item_lot_plan_datetime === undefined?'':Moment(item.item_lot_plan_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    item_lot_loss_datetime: item.item_lot_loss_datetime === undefined?'':Moment(item.item_lot_loss_datetime).format('YYYY-MM-DD HH:mm:ss'),
                }));
                setRows(array);
            })
            .catch((error) => {
                appStore.capture();
            });
        }
    }

    const handleInitSelect = () => {
        // 속도때문에 전체는 없앤다 무조건
        var array = [
            {value:'C', label:'생성'}
            ,{value:'D', label:'소멸'}
            ,{value:'L', label:'분실'}
            ,{value:'P', label:'계획'}
        ];
        setStatusOption(array);
    }

    const handleInit = () => {
        setKeyword({
            start_date: appStore.YYYY_MM_DD(),
            end_date: appStore.YYYY_MM_DD(),
            status:'C',
            search:''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            viewer: true,
            id: false,
            company_id: false,
            item_lotno: true,
            item_lotno_status: false,
            item_lotno_status_name: true,
            item_lot_create_type: false,
            item_lot_create_type_name: true,
            item_lot_create_datetime: true,
            item_lot_delete_type: false,
            item_lot_delete_type_name: true,
            item_lot_delete_datetime: true,
            item_id: false,
            item_version_seq: false,
            item_name: true,
            item_spec: true,
            item_width: false,
            item_depth: false,
            item_height: false,
            item_type: false,
            item_type_name: true,
            item_division: false,
            item_division_name: true,
            item_lot_c_produce_work_id: false,
            item_lot_c_incoming_id: false,
            item_lot_c_stock_adjustment_id: false,
            item_lot_c_quality_id: false,
            item_lot_l_loss_id: false,
            item_lot_p_produce_work_id: false,
            item_lot_d_produce_work_id: false,
            item_lot_d_outgoing_id: false,
            item_lot_d_stock_adjustment_id: false,
            item_lot_d_quality_discard_id: false,
            item_lot_d_discard_id: false,
            item_lot_save_workplace_id: false,
            item_lot_save_warehouse_id: false,
            item_lot_save_section_id: false,
            item_lot_save_workplace_name: false,
            item_lot_save_warehouse_name: false,
            item_lot_save_section_name: false,
            item_lot_save_name: true,
            item_lot_plan_datetime: false,
            item_lot_loss_datetime: false
        });
    };
    
    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onDateChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    const DetailClick = (object) => {
        setModalOpen(true);
        setModalTitle('Lot 상세');
        setSelectLotNo(object.row.id);
        setSelectLotNoStatusName(object.row.item_lotno_status_name);
        setSelectLotCreateTypeName(object.row.item_lot_create_type_name);
        setSelectLotCreateDatetime(object.row.item_lot_create_datetime);
        setSelectLotDeleteTypeName(object.row.item_lot_delete_type_name);
        setSelectLotDeleteDatetime(object.row.item_lot_delete_datetime);
        setSelectItemTypeName(object.row.item_type_name);
        setSelectItemDivisionName(object.row.item_division_name);
        setSelectItemName(object.row.item_name);
        setSelectItemSpec(object.row.item_spec);
        setSelectLotSaveName(object.row.item_lot_save_name);
        setSelectLotPlanDatetime(object.row.item_lot_plan_datetime);
        setSelectLotLossDatetime(object.row.item_lot_loss_datetime);
    };

    const handleExcel = () => {
        var filename = 'Lot조회'
        axios.get('/api/p/LotInfo/Excel',
        {   
            params : { status: keyword.status, start_date : keyword.start_date, end_date : keyword.end_date, search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" >
                            상태
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" onChange={(e) => onSelectChange('status',e.value)} value={statusOption.filter(function (option) { return option.value === keyword.status;  })} options={statusOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub" style={ { width: '550px', display: 'flex' } }>
                        <div className="menu-keyword-sub-title">
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                        ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%', fontSize: '17px' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isModalOpen && (
                        <LotInfoModal
                            onClose={() => {
                                setModalOpen(false);
                            }}
                            title={modalTitle}
                            id={selectLotNo}
                            lot_status_name={selectLotNoStatusName}
                            lot_save_name={selectLotSaveName}
                            lot_create_type_name={selectLotCreateTypeName}
                            lot_create_datetime={selectLotCreateDatetime}
                            lot_delete_type_name={selectLotDeleteTypeName}
                            lot_delete_datetime={selectLotDeleteDatetime}
                            item_type_name={selectItemTypeName}
                            item_division_name={selectItemDivisionName}
                            item_name={selectItemName}
                            item_spec={selectItemSpec}
                            lot_plan_datetime={selectLotPlanDatetime}
                            lot_loss_datetime={selectLotLossDatetime}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default LotInfo;